import menu from './en-US/menu';
import pages from './en-US/pages';
import match from './en-US/match';
import finance from './en-US/finance';

export default {
  ...pages,
  ...menu,
  ...match,
  ...finance,
};
